export {default as queue} from "./src/queue";



//////////////////
// WEBPACK FOOTER
// /Users/danielcorrea/Documents/Workshops/d3Angulr/angular-d3-example/~/d3-queue/index.js
// module id = ../../../../d3-queue/index.js
// module chunks = 3